/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteShiftTemplateRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {DeleteShiftTemplateResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const deleteShiftTemplate = (request: DeleteShiftTemplateRequest, options?: CashRequestOptions) => post<DeleteShiftTemplateRequest, DeleteShiftTemplateResponse>("/2.0/cash/delete-shift-template", request, {...options, rejectOnError: true })